export const fr = {
  title: `Psychosocial`,
  p1: `L’épilepsie peut avoir un impact psychosocial sur l’enfant. En effet, un enfant qui vit avec l’épilepsie peut ressentir du stress, avoir une faible estime de soi et/ou vivre de la colère. En effet, l’imprévisibilité des crises peuvent susciter beaucoup de stress chez l’enfant. La réaction de l’entourage peut également avoir un impact sur le stress vécu par l’enfant. Un entourage qui réagit de façon calme, rassurante et réconfortante plutôt que de manière agitée, aidera l’enfant à s’adapter à ce qu’il vit. D’ailleurs, un parent qui aide son enfant à voir l’épilepsie de façon positive et qui parle ouvertement de l’épilepsie avec son enfant, évitera de créer un tabou entourant la maladie.`,
  promoteWellBeing: {
    question: `Comment promouvoir le bien-être de votre enfant? Garder un rythme de vie NORMAL!`,
    bullets: [
      `Encourager son enfant à avoir une vie sociale active`,
      `Encourager son enfant à participer à des loisirs et des activités sportives`,
      `Encourager son enfant à participer aux tâches domestiques à la maison`,
      `Ne pas surprotéger son enfant et lui laisser de l’autonomie`
    ]
  },
  p2: `Lorsque vous apprenez que votre enfant a l’épilepsie, il se peut que vous soyez secoués, que vous éprouviez de la colère, du découragement, de l'impuissance, de la honte et même de la culpabilité. Vous vous demandez peut-être pourquoi cela arrive à votre enfant. Il faut se rappeler que ces réactions sont normales et qu'elles finiront par passer`,
  p3: `Truc: N’hésitez pas à faire appel à des ressources d’aide et surtout, parlez-en à votre médecin, il est aussi disponible pour accueillir vos émotions et vous offrir un soutien psychosocial.`,
  tips: {
    title: `Trucs pratiques pour améliorer mon quotidien et prévenir les crises`,
    bullets: [
      `Prendre ma médication de façon assidue`,
      `Boire assez d’eau`,
      `Manger sainement et de façon équilibrée`,
      `Limiter ma consommation d’alcool et de drogue`,
      `Prendre des douches plutôt que des bains`,
      `Éviter de verrouiller la porte de la salle de bain`,
      `Être accompagné pour les activités présentant un risque de chute ou qui sont dangereuses (ex. baignade)`
    ]
  },
  p4: {
    before: `Pour obtenir de l’informations sur les centres près de chez vous qui offrent des services de soutien psychologique, composez le 811 ou rendez-vous sur `,
    after: `.`,
    link: `https://www.ordrepsy.qc.ca`
  }
};
